/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IncomingInquiryDto } from '../../models/incoming-inquiry-dto';

export interface ApiAgencyinquiryEmptyInquiryGet$Params {
  'api-version'?: string;
}

export function apiAgencyinquiryEmptyInquiryGet(http: HttpClient, rootUrl: string, params?: ApiAgencyinquiryEmptyInquiryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<IncomingInquiryDto>> {
  const rb = new RequestBuilder(rootUrl, apiAgencyinquiryEmptyInquiryGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IncomingInquiryDto>;
    })
  );
}

apiAgencyinquiryEmptyInquiryGet.PATH = '/api/agencyinquiry/empty-inquiry';
